import React from 'react';
import { List, ListItem, Avatar, Box, Typography } from '@mui/material';
import { TierFeature } from '@/constants/subscriptionTiers';

interface TierFeaturesProps {
  features: TierFeature[];
}

export const TierFeatures: React.FC<TierFeaturesProps> = ({ features }) => {
  return (
    <List dense sx={{ textAlign: 'left', mb: 2, flex: 1 }}>
      {features.map((feature, index) => (
        <ListItem key={index} disablePadding>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
            width="100%"
            sx={{ py: 0.5 }}
          >
            <Avatar
              sx={{
                bgcolor: 'primary.light',
                color: 'primary.contrastText',
                width: 32,
                height: 32,
              }}
            >
              {React.isValidElement(feature.icon)
                ? React.cloneElement(feature.icon as React.ReactElement<any>, {
                    fontSize: 'small',
                  })
                : feature.icon}
            </Avatar>
            <Box flex={1}>
              <Typography variant="body2" fontWeight="medium">
                {feature.label}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {feature.value}
              </Typography>
            </Box>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};
